import React from "react";
import LocalizationContext from "../utils/LocalizationContext";
import NavBar from "../components/NavBar";
import PageContentLoading from "../components/PageContentLoading";
import useMenu from "../utils/Hooks/useMenu";
import useLocale from "../utils/Hooks/useLocale";
import ValidateURL from "../utils/ValidateURL";
import CavitestLive from "../pages/CavitestLive/CavitestLive";

export default () => {
  const menu = useMenu();
  const currentPage = {
    menuGroup: menu?.Cavitest,
    key: "Live",
  };

  // TODO: Replace 600 with actual screenName from backend
  const screenName = 600;
  const locale = useLocale(screenName);

  return (
    <ValidateURL currentPage={currentPage}>
      <LocalizationContext.Provider value={{ locale: locale }}>
        <NavBar
          screenName={screenName}
          moduleName={30}
          MenuOptions={menu}
          currentPage={currentPage}
        >
          {locale ? <CavitestLive /> : <PageContentLoading />}
        </NavBar>
      </LocalizationContext.Provider>
    </ValidateURL>
  );
};
